import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useSelector } from 'react-redux';

import Notification from './Notification';

import styles from './weatherNotifications.scss';

const WEATHER_NOTIFICATION_DISPLAY_LIMIT = 3;

const WeatherNotifications = (props) => {
    const { onEditWeatherNotification, 'data-testid': dataTestId } = props;
    const { event, weatherNotifications } = useSelector(({ eventProfile }) => {
        const { event, weatherNotifications } = eventProfile;
        return {
            event,
            weatherNotifications,
        };
    });

    const [showAll, setShowAll] = useState(false);

    const notificationsToDisplay = weatherNotifications.filter((notification, i) => {
        if (!showAll) {
            return i < WEATHER_NOTIFICATION_DISPLAY_LIMIT;
        }

        return true;
    });

    const onShowMoreClick = () => {
        setShowAll(!showAll);
    };

    const shouldDisplayShowMoreText = weatherNotifications.length > WEATHER_NOTIFICATION_DISPLAY_LIMIT;

    if (notificationsToDisplay.length > 0) {
        return (
            <>
                <h6 className="text-uppercase" data-testid={dataTestId && `${dataTestId}.title`}>Weather Updates</h6>
                <div className={styles.notificationContainer}>
                    {notificationsToDisplay.map((notification) => {
                        return (
                            <Notification
                                key={`weather-notification-${notification.id}`}
                                notification={notification}
                                event={event.data}
                                onEditWeatherNotification={onEditWeatherNotification}
                                data-testid={dataTestId && `${dataTestId}.notification-${notification.id}`}
                            />
                        );
                    })}
                    {shouldDisplayShowMoreText && (
                        <p
                            onClick={onShowMoreClick}
                            className="clickable text-teal"
                            data-testid={dataTestId && `${dataTestId}.show-more-btn`}
                        >
                            {showAll ? 'See less' : 'See more'}
                        </p>
                    )}
                </div>
            </>
        );
    }

    return null;
};

export default WeatherNotifications;

WeatherNotifications.defaultProps = {
    'data-testid': null,
};

WeatherNotifications.propTypes = {
    onEditWeatherNotification: PropTypes.func.isRequired,
    'data-testid': PropTypes.string,
};
